import {
  Card,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { PrizeDto } from "../../models/Lottery";
import { usePrize } from "../../hooks/usePrize";

interface IPrizeTableProps {
  prizes: PrizeDto[];
  lotteryTitle: string;
}

export const PrizeTable = ({ prizes, lotteryTitle }: IPrizeTableProps) => {
  const sortedPrizes = [...prizes].sort((a, b) => {
    if (a.referenceNumber == null) return -1;
    if (b.referenceNumber == null) return 1;
    return +b.referenceNumber - +a.referenceNumber;
  });
  const { deletePrize } = usePrize(undefined);

  const handleDelete = async (id: string) => {
    const confirmed = window.confirm(
      "Είσαι σίγουρος ότι θέλεις να διαγράψεις αυτό το δώρο;"
    );
    if (!confirmed) return;

    await deletePrize(id);
    window.location.reload();
  };

  const navigate = useNavigate();
  return (
    <Card style={{ width: "100%", padding: "1em" }}>
      <TableContainer>
        <Table size="medium">
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell width={"60px"}>Φώτο</TableCell>
              <TableCell>Όνομα</TableCell>
              <TableCell>Περιγραφή</TableCell>
              <TableCell align="right">Ποσότητα</TableCell>
              <TableCell align="right">Κλήρωση</TableCell>
              <TableCell align="center">A/A</TableCell>
              <TableCell align="center">Ενέργιες</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedPrizes?.map((row: any, i) => (
              <TableRow
                key={i}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell scope="row">{i + 1}</TableCell>
                <TableCell padding="none" align="center">
                  {row.image ? (
                    <img
                      width={"100px"}
                      src={`data:image/jpeg;base64,${row.image}`}
                      alt={"noimage"}
                    />
                  ) : (
                    <Typography variant="h4">🎁</Typography>
                  )}
                </TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.description}</TableCell>
                <TableCell align="right">{row.quantity}</TableCell>
                <TableCell align="right">{lotteryTitle}</TableCell>
                <TableCell align="center">{row.referenceNumber}</TableCell>
                <TableCell>
                  <Stack direction="row" spacing={2}>
                    <IconButton
                      size="small"
                      onClick={() => navigate(`/prizes/${row.id}`)}
                      sx={{ ml: "auto", color: "hsla(55, 71%, 51%, 1.00)" }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleDelete(row.id)}
                      sx={{ ml: "auto", color: "hsl(0, 60%, 50%)" }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};
